import history from 'browserHistory'
import RoutesHelper from 'helpers/RoutesHelper'
import get from 'lodash/get'

import { selectors as UISelectors } from 'data/ui'

function redirectOnNoteRemoval(store, action) {
  const noteIdsToRedirect = get(action, 'metadata.noteIdsToRedirect', [])
  const activeNoteId = UISelectors.getActiveNoteId(store.getState())

  if (
    noteIdsToRedirect.length > 0 &&
    activeNoteId &&
    noteIdsToRedirect.includes(activeNoteId)
  ) {
    const channelId = UISelectors.getActiveChannelId(store.getState())
    const filterId = UISelectors.getActiveFilterId(store.getState())

    const route = filterId
      ? RoutesHelper.filterShow({ filterId })
      : RoutesHelper.noteChannelIndex({ channelId })
    history.push(route)
  }
}

const noteMiddleware = store => next => action => {
  const returnValue = next(action)
  redirectOnNoteRemoval(store, action)
  return returnValue
}

export default noteMiddleware
